<template>
  <q-dialog
    ref="dialog"
    persistent
    content-class="custom-dialog"
    @hide="onDialogHide"
  >
    <q-card class="full-width text-center q-pa-lg border-radius-8">
      <!-- 图标 -->
      <q-card-section class="icon no-padding q-mb-sm">
        <img
          v-if="customIcon"
          style="max-width: 80%; max-height: 100px; margin-top: 4px;"
          :src="customIcon"
        />
        <TypeIcon v-else :type="type" />
      </q-card-section>
      <!-- 标题 -->
      <q-card-section class="title no-padding">
        <div class="text-weight-bolder font-size-18 line-height-24">
          <span style="white-space: pre-line;" v-html="title" />
        </div>
      </q-card-section>
      <!-- 描述 -->
      <q-card-section v-if="describe" class="desc no-padding">
        <div class="greyColor font-size-14 line-height-24">
          <div v-html="describe" />
        </div>
      </q-card-section>
      <!-- 额外内容 -->
      <q-card-section v-if="extras" class="no-padding">
        <div class="greyColor font-size-12">
          <span>{{ extras }}</span>
        </div>
      </q-card-section>
      <!-- 操作按钮 -->
      <q-card-actions vertical class="operation q-mt-lg">
        <q-btn
          v-if="ok"
          bold
          no-caps
          unelevated
          color="primary"
          class="confirm"
          :label="ok"
          @click="onOKClick"
        />
        <q-btn
          v-if="cancel"
          no-caps
          :label="cancel"
          class="cancel"
          @click="onCancelClick"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import TypeIcon from './TypeIcon.vue';

export default {
  components: { TypeIcon },
  props: {
    type: {
      type: String,
      default: 'error',
    },
    customIcon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'System Error',
    },
    describe: {
      type: String,
      default: '',
    },
    extras: {
      type: Object,
      default: () => {},
    },
    ok: {
      type: String,
      default: '',
    },
    cancel: {
      type: String,
      default: '',
    },
  },

  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide() {
      this.$emit('hide');
    },
    onOKClick() {
      this.$emit('ok');
      this.hide();
    },
    onCancelClick() {
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  line-height: 1.2;
}
.desc {
  line-height: 1.2;
  margin-top: 8px;
}
.custom-dialog {
  .operation {
    padding: 0 22px;
    .q-btn {
      border-radius: 8px;
      &.cancel {
        margin-top: 16px !important;
        background-color: #eee !important;
        outline: none !important;
        .q-btn__wrapper:before {
          border-color: #d1d5db;
        }
      }
    }
  }
}
</style>
